const store = {
    namespaced: true,
    state() {
        return {
            departmentsData: null,
        };
    },
    getters: {
        departmentsData: state => state.departmentsData,
    },
    mutations: {
        SET_DEPARTMENTS_DATA: (state, data) => (state.departmentsData = data),
    },
    actions: {
        fetchDepartmentsData: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/main-carousel-category/`,
                });
                commit('SET_DEPARTMENTS_DATA', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
    },
};

export default store;
